export default __webpack_public_path__ + "static/media/protocolo_tratamiento_ortodoncia_ortopedia.f6f9599a.pdf";